import { Box, Typography } from '@mui/material'
import ProductTitle from './ProductTitle'

const PublicRecordingHeader: React.FC = () => (
  <Box
    component="header"
    sx={{
      px: { xs: 2, sm: 3 },
      py: 2,
      borderBottom: 1,
      borderColor: 'divider',
      bgcolor: 'background.paper',
    }}
  >
    <ProductTitle size="small" centered={false} layout="horizontal" />
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, ml: 0.5 }}>
      Session recording
    </Typography>
  </Box>
)

export default PublicRecordingHeader
